<div class="modal-header container-md" id="modal-header">
  <div class="col-11 modal-title">
    {{ label() }}
  </div>
  <div class="col-1">
    <button
      id="closeButton"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.close()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="modal-body mx-3">
  <div class="d-flex flex-column">
    <div
      id="allButton"
      class="option-btn d-flex justify-content-between"
      [class.selected]="selectedNode() == null"
      (click)="onSelectAll()"
      (keypress)="onSelectAll()"
    >
      <div>{{ "IDS_ALL" | translate }}</div>
      <div>{{ auctionsCount() }}</div>
    </div>

    @for(category of treeCategories(); track category.key){
    <div
      class="selected-category"
      [class.expanded-dropdown]="category.data.expanded"
    >
      @if(category.children.length > 0){
      <div
        id="selectedCategories"
        class="option-group d-flex justify-content-between"
        [class.expanded]="category.data.expanded"
        (click)="toggleDropdown(category)"
        (keypress)="toggleDropdown(category)"
      >
        {{ category.label }}
        <div class="arrow-icon"></div>
      </div>
      }

      @if(category.children.length === 0){
      <div
        id="selectedCategories"
        class="option-btn d-flex justify-content-between"
        [class.selected]="selectedNode()?.key == category.key"
        (click)="onNodeSelect(category)"
        (keypress)="onNodeSelect(category)"
      >
        <div>{{ category.label }}</div>
        <div>{{ category.data.auctionsCount }}</div>
      </div>
      }

      @if(category.data.expanded){
      <div>
        <div
          id="allButton"
          class="option-btn option-group-btn d-flex justify-content-between"
          [class.selected]="selectedNode()?.key == category.key"
          (click)="onNodeSelect(category)"
          (keypress)="onNodeSelect(category)"
        >
          <div>{{ "IDS_ALL" | translate }} {{ category.label }}</div>
          <div>{{ category.data.auctionsCount }}</div>
        </div>
        @for(sub of category.children; track sub.key){
        <div
          (click)="onNodeSelect(sub)"
          (keypress)="onNodeSelect(sub)"
          class="option-btn option-group-btn d-flex justify-content-between"
          [class.selected]="selectedNode()?.key == sub.key"
        >
          <div>{{ sub.label }}</div>
          <div>{{ sub.data.auctionsCount }}</div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
